import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=50e6fae3&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"
import style0 from "./Step3.vue?vue&type=style&index=0&id=50e6fae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e6fae3",
  null
  
)

export default component.exports